import { Button, Flex, Space, Typography } from 'antd';
import dayjs from 'dayjs';

import { statusList } from './orders';
import { renderSplitPrice } from '../../../../../utils/common/renderSpiltPrice';
import { rub } from '../../../../../shared/contants/styles';

const { Text, Link } = Typography;

export const getColumns = (getColumnSearchProps, updateFilters, viewOrder) => [
    {
        title: <Text strong>Номер заказа</Text>,
        dataIndex: 'id',
        key: 'id',
        sorter: (a, b) => a.id - b.id,
        ...getColumnSearchProps('id', 'номеру'),
    },
    {
        title: <Text strong>Дата заказа</Text>,
        dataIndex: 'created_at',
        key: 'created_at',
        render: created_at => (
            <Flex>
                <Text>{dayjs(created_at).format('DD.MM.YYYY')}</Text>
            </Flex>
        ),
        sorter: (a, b) =>
            dayjs(a.created_at).unix() - dayjs(b.created_at).unix(),
    },
    {
        title: <Text strong>Статус</Text>,
        dataIndex: 'status',
        filters: statusList,
        filterDropdown: ({ close }) => (
            <div style={{ padding: 8 }}>
                <Flex vertical gap={8}>
                    {statusList.map((status, index) => (
                        <Text
                            style={{ cursor: 'pointer' }}
                            key={index}
                            onClick={() => {
                                close();
                                updateFilters({ status: status.value });
                            }}
                        >
                            {status.label}
                        </Text>
                    ))}
                </Flex>
            </div>
        ),
        render: status => (
            <Button
                size={'small'}
                style={{
                    cursor: 'not-allowed',
                    pointerEvents: 'none',
                }}
            >
                <Space>{status}</Space>
            </Button>
        ),
    },
    {
        title: <Text strong>Сумма заказа</Text>,
        dataIndex: 'total_price',
        key: 'total_price',
        render: total_price => (
            <Flex>
                <Text>
                    {renderSplitPrice(total_price)} {rub}
                </Text>
            </Flex>
        ),
    },
    {
        title: <Text strong>Телефон</Text>,
        dataIndex: 'phone',
        key: 'phone',
        ...getColumnSearchProps('phone', 'телефону'),
    },
    {
        title: <Text strong>Юзернейм</Text>,
        dataIndex: 'username',
        key: 'username',
        render: username =>
            username && (
                <Flex>
                    <Text>@{username}</Text>
                </Flex>
            ),
        ...getColumnSearchProps('telegram_username', 'юзернейму'),
    },
    {
        title: '',
        key: 'operation',
        fixed: 'right',
        render: ({ id }) => (
            <Link onClick={() => viewOrder(id)}>Подробнее</Link>
        ),
    },
];
